module.exports = __webpack_public_path__ + "img/spidercracks_overlay.4e764033.jpeg";